/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplicate_Item_ReclaimedInputs */

const en_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate Turned Into`)
};

const ar_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحويل المكافأة المكررة إلى`)
};

const de_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplikat umgewandelt in`)
};

const es_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicado convertido en`)
};

const fr_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doublon converti en`)
};

const it_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppione convertito in`)
};

const ja_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複アイテムの変換`)
};

const ko_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중복 아이템 변환`)
};

const pt_br_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicata convertida em`)
};

const ru_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дубликат превращен в`)
};

const th_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลซ้ำเปลี่ยนเป็น`)
};

const tr_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yinelenen şuna dönüştü`)
};

const zh_cn_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重复奖励转换为`)
};

const zh_tw_duplicate_item_reclaimed = /** @type {(inputs: Duplicate_Item_ReclaimedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複獎勵轉換為`)
};

/**
* | output |
* | --- |
* | "Duplicate Turned Into" |
*
* @param {Duplicate_Item_ReclaimedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const duplicate_item_reclaimed = /** @type {((inputs?: Duplicate_Item_ReclaimedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_Item_ReclaimedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duplicate_item_reclaimed(inputs)
	if (locale === "ar") return ar_duplicate_item_reclaimed(inputs)
	if (locale === "de") return de_duplicate_item_reclaimed(inputs)
	if (locale === "es") return es_duplicate_item_reclaimed(inputs)
	if (locale === "fr") return fr_duplicate_item_reclaimed(inputs)
	if (locale === "it") return it_duplicate_item_reclaimed(inputs)
	if (locale === "ja") return ja_duplicate_item_reclaimed(inputs)
	if (locale === "ko") return ko_duplicate_item_reclaimed(inputs)
	if (locale === "pt_br") return pt_br_duplicate_item_reclaimed(inputs)
	if (locale === "ru") return ru_duplicate_item_reclaimed(inputs)
	if (locale === "th") return th_duplicate_item_reclaimed(inputs)
	if (locale === "tr") return tr_duplicate_item_reclaimed(inputs)
	if (locale === "zh_cn") return zh_cn_duplicate_item_reclaimed(inputs)
	return zh_tw_duplicate_item_reclaimed(inputs)
});